import { render } from "./GlobalComponents.vue?vue&type=template&id=4d80a0ce"
import script from "./GlobalComponents.vue?vue&type=script&lang=js"
export * from "./GlobalComponents.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__